import type { CashDenominationDto } from './cash-sessions.dto.js';

export const cashTransferTypeValues = ['transfer', 'drop'] as const;
export type CashTransferType = (typeof cashTransferTypeValues)[number];

// Monetary amounts are in minor units (e.g., cents).
export interface CashTransferDto {
  id: string;
  companyId: string;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  fromCashLocationId: string;
  toCashLocationId: string;
  amount: number;
  type: CashTransferType;
  notes: string | null;
  createdByUserId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashTransferRequest {
  companyId: string;
  type: CashTransferType;
  fromCashLocationId: string;
  toCashLocationId: string;
  stationId?: string;
  storeId?: string;
  locationId?: string;
  amount: number;
  notes?: string | null;
  denominations?: CashDenominationDto[] | null;
}

export interface CreateCashTransferResponse {
  cashTransfer: CashTransferDto;
  warnings?: string[];
}

export interface ListCashTransfersRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  type?: CashTransferType;
  from?: string;
  to?: string;
}

export interface ListCashTransfersResponse {
  items: CashTransferDto[];
}
